// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"ba140ef3","155":"d05de72c","265":"adf1af40","551":"7d5a2ee9","615":"f6fd1ca6","629":"35880474","682":"2a543176","727":"b0bfb257","814":"b5978e88","815":"4da92ed1","953":"f16badec","978":"854fba80"}[chunkId] + ".chunk.js";
};